import React, { useEffect, useState } from "react";
import { useMemberstack } from "@memberstack/react";
import { CheckIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";

function OnboardAbonnementNotaire() {
  const memberstack = useMemberstack();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);

  useEffect(() => {
    memberstack
      .getCurrentMember()
      .then(({ data }) => {
        if (!data) {
          navigate("/app/connexion", { replace: true });
          return;
        }
        setMember(data);
      })
      .catch(console.error);
  }, [memberstack, navigate]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  if (!member) {
    return <div className="min-h-screen flex items-center justify-center">Chargement…</div>;
  }

  return (
    <main className="grid min-h-full place-items-center bg-gradient-to-b from-indigo-100 to-pink-100 px-6 py-24 sm:py-24 lg:px-8">
      <div className="text-left mb-5">
        <p className="flex items-center text-md font-bold tracking-tight text-gray-500 sm:text-md">
          <CheckIcon className="size-6" /> Renseignez vos informations personnelles
        </p>
        <p className="flex items-center text-md font-bold tracking-tight text-gray-500 sm:text-md">
          <CheckIcon className="size-6" /> Complétez votre fiche notaire
        </p>

        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Activez votre abonnement
        </h1>

        <p>
          Pour profiter de votre tarif préférentiel sur vos 3 premiers mois,
          renseignez à l'étape de paiement ce code promotionnel : <b>NEWNOTAIRE</b>
        </p>
      </div>

      <div className="w-full max-w-3xl">
        <stripe-pricing-table
          pricing-table-id="prctbl_1TCfgRBu5KNLzGouLKFyQIK7"
          customer-email={member.auth.email}
          client-reference-id={member.metaData.airtable_id}
          publishable-key="pk_live_51OpXo5Bu5KNLzGou1u8OUu2RGy7qotXuLHB1fWLLT4b3vm24tvvUKG2QMxQJspEAR55fc5CSYjwE97q3Wo5rtfdH00bWVWLyEL"
        />
      </div>
    </main>
  );
}

export default OnboardAbonnementNotaire;